import React from 'react';
import { FC } from 'react';
import Students from '../../common/Students';

const GUStudents: FC = () => {
  return <Students all={false} />;
};

export default GUStudents;
